module.exports = __webpack_public_path__ + "img/5.06.thmb.xs.46e12863.jpg";